import styles from './styles.module.scss'

export default function Footer(){
    return(
        <footer className={styles.footer}>
            <span>Application powered by</span>
            <img src={'/icons/diplo.svg'} width={71} height={22.5} alt={'Diplo logo'}/>
        </footer>
    )
}